import React, { ReactElement, Suspense } from "react";
import "./styles/App.scss";
import VersionDisplay from "./components/VersionDisplay";
import LoadingOverlay from "./components/LoadingOverlay";
import Footer from "./components/Footer";
import Home from "./components/Home";
import { Route, Switch } from "react-router";
import CodeScreen from "./components/CodeScreen";
import { initDatadog } from "./tools/analytics";
import ShareScreen from "./components/ShareScreen";
import HtmlVersionLauncher from "./components/HtmlVersionLauncher";

initDatadog();

function App(): ReactElement {
	return (
		<Suspense fallback={<div>Loading...</div>}>
			<Switch>
				<Route path="/share/:code" component={ShareScreen} />
				<Route path="/htmlVersion/:code" component={HtmlVersionLauncher} />
				<Route path="/htmlVersion" component={HtmlVersionLauncher} />
				<Route path="/:code" component={CodeScreen} />
				<Route path="/" component={Home} />
			</Switch>
			<Footer />
			<VersionDisplay />
			<LoadingOverlay />
		</Suspense>
	);
}

export default App;
